import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { MsalService }from '@azure/msal-angular';
import { AboutComponent } from '../about/about.component';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { MLService } from '../services/ml-service';
import { ThemeService } from '../services/theme.service';
import { RefineryService } from '../services/refinery.service';
import { Refinery } from '../models/refinery.model';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  userName: string;
  userShortName: string;
  rbacName = '';
  countryCode: any;
  countryList: any;
  releaseDetails: any;

  unreadNotifications = 0;
  zeroNotification = false;
  errorNotification = false;
  hideNotificationNumber = false;
  dateString: string;
  notificationLimit = 10;
  refineryName: string;
  refinerytMap: Refinery[];

  constructor(private readonly authService: MsalService, public mlServie: MLService,
    public dialog: MatDialog, public globals: Globals, public globalService: GlobalService,
    private readonly refineryService: RefineryService,
    public themeService: ThemeService, public _router: Router) {
    this.countryList = [
      {
        'Id': 1,
        'Name': 'English',
        'Code': 'EN',
      },
    ];
  }

  ngOnInit() {
    this.themeService.setDarkTheme();
    this.getReleaseDetails();
    this.countryCode = 'EN';
    $('#handberg').click(function () {
      $('.row-offcanvas').toggleClass('active');
      $('.collapse').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });

    $('#close-sidebar').click(function () {
      $('.page-wrapper').removeClass('toggled');
    });
    $('#show-sidebar').click(function () {
      $('.page-wrapper').addClass('toggled');
    }); 
    this.getRefineriesList()
  }

callByRefineryNameNotMatch(){
  this.refinerytMap.forEach((u, index) => {
    if (this.refineryName === u.refineryName) {
      this.onRefineryChange(this.refinerytMap[index], false);
    }
  });
}

callByRefineryName(){
  this.onRefineryChange(this.refinerytMap[0], false);
  this.refineryService.refinerySelected.next(this.refinerytMap[0]);
}

  getRefineriesList() {
    if (!this.refinerytMap || this.refinerytMap == undefined || this.refinerytMap == null || this.refinerytMap.length == 0) {
      this.refineryService.getRefineries().subscribe((data: Refinery[]) => {
        this.refinerytMap = data;
        this.refinerytMap.sort((a: any, b: any) => (a.refineryName > b.refineryName ? 1 : -1));
        if (this.refineryName && this.refineryName !== this.refinerytMap[0].refineryName) {
          this.callByRefineryNameNotMatch();
        }
        else {
          this.callByRefineryName();
        }
      });
    }    
  }

  logout() {
    this.authService.logout();
  }

  // show about dialog for version, build date and build number
  openAboutRelease(): void {
     this.dialog.open(AboutComponent, {
        data: this.releaseDetails,
      });
    
  }

  getReleaseDetails() {
    this.releaseDetails = this.globals.releaseDetails;
  }

  selectFlag(Code: any) {
    this.countryCode = Code;
  }

  toggleTheme() {
    if (this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
  }

  /**
  * Used for switching tenants and redirection to particular page
  * @param tenant tenant to be updated
  */
  onRefineryChange(refinery: Refinery, isCallFromUI?: boolean) {
    this.refineryName = refinery.refineryName;
    this.refineryService.setCurrentRefinery(refinery);
    if(isCallFromUI){
      this.refineryService.refinerySelected.next(refinery);
    }
    this._router.navigate(['tenant']);
  }
}

